export default function ServiceAreas() {
  return (
    <section id="areas" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Our <strong>Service Areas</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            <strong>Cleaning services</strong> available throughout the <strong>Cumberland</strong> region
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h4 className="text-2xl font-bold text-gray-900 mb-6">
                Main Areas
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className="ri-map-pin-fill text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">Cumberland</h5>
                    <p className="text-gray-600">Complete cleaning service for homes, offices and businesses</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">Surrounding Areas</h5>
                    <p className="text-gray-600">Yarmouth, Falmouth, Gray and other nearby cities</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-teal-50 rounded-xl">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-2xl text-teal-600 flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">Your area not listed?</p>
                    <p className="text-gray-700">Contact us! We regularly expand our service areas in the Cumberland region.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92682.89476419!2d-70.2568!3d43.7970!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb29bf9f1e6e5e5%3A0x7e9db6b53372fa29!2sCumberland%2C%20ME%2C%20USA!5e0!3m2!1sen!2s!4v1234567890"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Cumberland service map"
              ></iframe>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="bg-white rounded-xl shadow p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3">
                  <i className="ri-car-line text-2xl text-teal-600"></i>
                </div>
                <p className="font-semibold text-gray-900">Fast Travel</p>
                <p className="text-sm text-gray-600 mt-1">Throughout the area</p>
              </div>
              <div className="bg-white rounded-xl shadow p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3">
                  <i className="ri-24-hours-line text-2xl text-teal-600"></i>
                </div>
                <p className="font-semibold text-gray-900">7 Days Service</p>
                <p className="text-sm text-gray-600 mt-1">Maximum availability</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
